class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-stl-open]');
    this.backdrop = this.querySelector('[data-stl-backdrop]');
    this.sheet = this.querySelector('.hm-stl__sheet');
    this.closeBtn = this.querySelector('[data-stl-close]');
    this.tabs = Array.from(this.querySelectorAll('[data-stl-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-stl-panel]'));

    if (!this.trigger || !this.sheet) return;

    this.placeTrigger();
    document.body.append(this.backdrop, this.sheet);

    this.trigger.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());
    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab.dataset.stlTab)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close();
    });
  }

  placeTrigger() {
    const media = document.querySelector('.product-information__media');
    if (!media) return;
    const items = Array.from(media.querySelectorAll('.product-media-container'));
    this.anchor = items.find((el) => el.offsetParent !== null && el.offsetHeight > 0) || items[0];
    this.mediaEl = media;
    media.style.position = 'relative';
    media.append(this.trigger);

    if (!this.anchor) return;
    this.positionTrigger();
    const reposition = () => this.positionTrigger();
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(reposition);
      observer.observe(this.anchor);
      observer.observe(media);
    }
    window.addEventListener('resize', reposition);
    this.anchor.querySelector('img')?.addEventListener('load', reposition);
  }

  positionTrigger() {
    if (!this.anchor || !this.mediaEl) return;
    const media = this.mediaEl.getBoundingClientRect();
    const anchor = this.anchor.getBoundingClientRect();
    this.trigger.style.position = 'absolute';
    this.trigger.style.left = 'auto';
    this.trigger.style.bottom = 'auto';
    this.trigger.style.top = `${anchor.bottom - media.top - this.trigger.offsetHeight - 16}px`;
    this.trigger.style.right = `${media.right - anchor.right + 16}px`;
  }

  open() {
    this.isOpen = true;
    this.backdrop.hidden = false;
    this.sheet.hidden = false;
    void this.sheet.offsetWidth;
    this.backdrop.classList.add('is-open');
    this.sheet.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    this.tabs[0]?.focus();
  }

  close() {
    this.isOpen = false;
    this.backdrop.classList.remove('is-open');
    this.sheet.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    const hide = () => {
      this.backdrop.hidden = true;
      this.sheet.hidden = true;
      this.sheet.removeEventListener('transitionend', hide);
    };
    this.sheet.addEventListener('transitionend', hide);
    this.trigger.focus();
  }

  selectTab(name) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.stlTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      const active = panel.dataset.stlPanel === name;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }
}

customElements.define('shop-the-look', ShopTheLook);
